<template>
  <div>
    <footer id="page-footer" class="uk-margin-top">
      <div class="uk-container uk-padding-small">
        <div class="uk-section uk-section-muted" id="color">
          <div class="uk-container">
            <div class="uk-grid-match uk-child-width-1-4@m" uk-grid>
              <div>
                <h3 class="uk-margin-bottom uk-text-left">Modelos</h3>
                <a
                  @click="$router.push({ path: '/autos/ciaz' })"
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  Ciaz
                </a>
                <a
                  @click="$router.push({ path: '/autos/ertiga' })"
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  Ertiga XL7
                </a>
                <a
                  @click="$router.push({ path: '/autos/ignis' })"
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  Ignis
                </a>

                <a
                  @click="$router.push({ path: '/autos/swift' })"
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  Swift
                </a>

                <a
                  @click="$router.push({ path: '/autos/swift-sport' })"
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  Swift Sport
                </a>
                <a
                  @click="$router.push({ path: '/autos/s-cross' })"
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  S-Cross
                </a>
                <a
                  @click="$router.push({ path: '/autos/ErtigaBoostergreen' })"
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  ERTIGA BOOSTERGREEN
                </a>
                <a
                  @click="
                    $router.push({ path: '/autos/ErtigaXL7Boostergreen' })
                  "
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  ERTIGA XL7 BOOSTERGREEN
                </a>
                <a
                  @click="$router.push({ path: '/autos/baleno' })"
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  Baleno
                </a>

                <a
                  @click="$router.push({ path: '/autos/SwiftBoostergreen' })"
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  Swift Boostergreen
                </a>

                <a
                  @click="$router.push({ path: '/autos/jimny' })"
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  JIMNY
                </a>

                <a
                  @click="$router.push({ path: '/autos/GrandVitra' })"
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  Grand Vitara
                </a>

                <a
                  @click="$router.push({ path: '/autos/FRONXBOOSTERGREENGLX' })"
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  FRONX BOOSTERGREEN
                </a>
                <a
                  @click="$router.push({ path: '/autos/SWiftBoostergreen2025' })"
                  class="uk-button uk-button-text btnword uk-margin-bottom uk-text-left footerbtn"
                >
                  Nuevo Swift Boostergreen 2025
                </a>
              </div>

              <div>
                <h3 class="uk-text-left">Post Venta</h3>
                <a
                  @click="$router.push({ path: '/garantias' })"
                  class="uk-button uk-button-text btnword uk-text-left footerbtn2"
                >
                  Garantía ordinaria
                </a>
                <a
                  @click="$router.push({ path: '/garantias' })"
                  class="uk-button uk-button-text btnword uk-text-left footerbtn2"
                >
                  Garantía extendida
                </a>

                <a
                  @click="$router.push({ path: '/costos-de-mantenimiento' })"
                  class="uk-button uk-button-text btnword uk-text-left footerbtn2"
                >
                  Costos de mantenimiento
                </a>
                <a
                  @click="$router.push({ path: '/proteccion-suzuki' })"
                  class="uk-button uk-button-text btnword uk-text-left footerbtn2"
                >
                  Protección Suzuki
                </a>
              </div>

              <div>
                <h3 class="uk-text-left">Compra</h3>
                <a
                  class="uk-button uk-button-text btnword uk-text-left footerbtn2"
                  @click="$router.push({ path: '/PruebaDeManejo' })"
                >
                  Agenda una prueba de manejo
                </a>
                <a
                  class="uk-button uk-button-text btnword uk-text-left footerbtn2"
                  @click="$router.push({ path: '/modelos' })"
                >
                  Cotiza tu SUZUKI
                </a>

                <a
                  @click="$router.push({ path: '/contacto' })"
                  class="uk-button uk-button-text btnword uk-text-left footerbtn2"
                >
                  Contáctanos
                </a>
              </div>

              <div>
                <div>
                  <h3 class="uk-margin-bottom uk-text-left">Redes Sociales</h3>
                  <a
                    href="https://www.facebook.com/SuzukiAutosDurango"
                    target="_blank"
                    class="uk-button uk-button-text btnword uk-text-left miclase footerbtn2"
                  >
                    <span uk-icon="facebook"></span> Facebook
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCLmciGikSEN3KdDRD5Nw9Vg?view_as=subscriber"
                    target="_blank"
                    class="uk-button uk-button-text btnword uk-text-left footerbtn2"
                  >
                    <span uk-icon="youtube"></span> Youtube
                  </a>
                  <a
                    href="https://www.instagram.com/suzukidgo/"
                    target="_blank"
                    class="uk-button uk-button-text btnword uk-text-left footerbtn2"
                  >
                    <span uk-icon="instagram"></span> Instagram
                  </a>
                </div>

                <div>
                  <h3 class="uk-margin-bottom uk-text-left">Contacto</h3>

                  <a
                    href="tel:6181503950"
                    target="_blank"
                    class="link-nodecoration uk-button-text btnword uk-text-left miclase"
                  >
                    <span uk-icon="receiver"></span> (618) 150-3950
                  </a>

                  <a
                    @click="$router.push({ path: '/contacto' })"
                    target="_blank"
                    class="uk-text-justify uk-display-block link-nodecoration uk-button-text btnword uk-text-left miclase uk-margin-medium-top"
                  >
                    <span uk-icon="location"></span>
                    Blvd. Francisco Villa 4001, Blvd. Francisco Villa. Colonia
                    20 de Noviembre Victoria de Durango.
                  </a>
                </div>
              </div>

              <div class="uk-width">
                <hr />
                <div class="uk-grid uk-child-width-expand">
                  <a class="none-style uk-text-small">
                    © 2024 SUZUKI AUTOS DURANGO. TODOS LOS DERECHOS RESERVADOS
                  </a>

                  <div class="uk-text-right">
                    <a
                      href="https://cdn.marciano.space/suzuki/legal/150429-Aviso-de-Privacidad-Integral.pdf"
                      target="_blank"
                      class="none-style uk-margin-small-left@s uk-text-small uk-padding-small"
                    >
                      Aviso de privacidad
                    </a>

                    <a
                      href="https://cdn.marciano.space/suzuki/legal/Formato-solicitud-derechos-ARCO.pdf"
                      target="_blank"
                      class="none-style uk-margin-small-left@s uk-text-small uk-padding-small"
                    >
                      Formato Arco
                    </a>

                    <a
                      class="none-style uk-margin-small-left@s uk-text-small uk-padding-small"
                      @click="$router.push({ path: '/terminos-y-condiciones' })"
                    >
                      Términos y condiciones
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss">
@import "@/scss/_variables.scss";

#page-footer {
  margin-top: 100px !important;
}

h3 {
  color: #ffffff;
  margin-bottom: 5px;
}

#page-footer {
  background-color: #000;
  color: #ffffff;
}

#color {
  background-color: #000;
}

.btnword {
  color: #ffffff;
}

.footerbtn {
  padding: 10px;
  vertical-align: center;
}

.footerbtn2 {
  height: 36px;
  vertical-align: middle;
  display: block;
  padding: 7px;
}
footer button:hover,
footer a:hover {
  color: #fff6ee !important;
  border-color: #fff6ee !important;
  // background-color: rgba(20,20,20,0.7);
}

footer button:hover,
footer a:before {
  color: #fff6ee !important;
  border-color: #fff6ee !important;
  // background-color: rgba(20,20,20,0.7);
}

#page-footer,
footer div {
  background-color: #030b0f !important ;
}
</style>
